export const hasAlphaNum = /[A-Z]|[a-z]|\d/;
export const hasSymbol = /[~#@$%&!*_?^-]/;